<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Manage Vouchers</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="refreshList()" class="white--text">
        <v-icon>autorenew</v-icon>
      </v-btn>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer" class="white--text">
        <v-icon>filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      temporary
      right
      v-model="rightDrawer"
      fixed
      app
      :width=500
    >
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex
            xs12
            text-xs-center
            layout
            align-center
            justify-center
            class="pl-4 pr-4"
          >
            <v-form ref="form" v-model="frmValid" @submit.prevent="">
              <v-text-field
                v-model="txtName"
                label="Name"
                @keyup.enter="items=[]; getVouchers(txtName, cboSort); rightDrawer=false;"
              ></v-text-field>
              <v-select
                v-model="cboSort"
                :items="sorts"
                item-text="caption"
                item-value="value"
                label="Sorting"
              ></v-select>
              <v-btn
                :disabled="!frmValid"
                @click="items=[]; getVouchers(txtName, cboSort); rightDrawer=false;"
              >
                Filter
              </v-btn>
              <v-btn @click="clearFilter">Reset</v-btn>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-content>
      <v-list two-line fill-height>
        <template
          v-for="(item, index) in items"
        >
          <v-list-tile
            :key="item.voucherTypeId"
            avatar
            ripple
            :class="(index % 2 === 0 ? 'row1' : 'row2')"
          >
            <v-list-tile-action>
              <v-list-tile-action-text>
                <div class="subheading">{{ item.currencyCode }}</div>
              </v-list-tile-action-text>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>
                <router-link class="font-weight-bold orange--text text--lighten-2" :to="'/voucher/' + item.voucherTypeId">{{ item.name }}</router-link>
              </v-list-tile-title>
              <v-list-tile-sub-title class="text--primary caption">
                <span v-if="item.maxDiscountPercentage > 0" class="mr-3">Max discount: {{ item.maxDiscountPercentage }}%</span>
                <span v-if="item.maxDiscountAmount > 0" class="mr-3">Max amount: {{ item.currencySign + formatPrice(item.maxDiscountAmount, item.currencyDecimals, item.currencyDecimalSign) }}</span>
                <span>Minimum purchase: {{ item.currencySign + formatPrice(item.minimumPurchase, item.currencyDecimals, item.currencyDecimalSign) }}</span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title class="caption">
                <v-btn outline small class="ml-0 pl-3 pr-3 caption" :to="'/voucher/' + item.voucherTypeId + '/codes'">
                  View Codes
                </v-btn>
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-list-tile-action-text class="text-xs-right white--text">
                <div>First purchase only: <strong>{{ (item.isFirstPurchaseOnly === '1' ? 'Yes' : 'No') }}</strong>, Mixable: <strong>{{ (item.isMixable === '1' ? 'Yes' : 'No') }}</strong></div>
                <div>Category whitelist / blacklist: <strong>{{ item.categoryFilter | capitalize }}</strong></div>
                <div>Created by {{ item.createdByAdminName }} ({{ item.createdDateTimeDisplay }})</div>
              </v-list-tile-action-text>
            </v-list-tile-action>

            <v-btn outline small class="caption" :to="'/voucher/' + item.voucherTypeId">
              Edit
            </v-btn>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </template>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No voucher yet
            </div>
          </v-flex>
        </template>
      </v-list>

      <v-container fluid grid-list-xs class="mt-3 mb-0">
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center">
            <div class="mb-3">
              Showing {{ listCountFrom }} - {{ listCountTo }} of {{ listTotal }} orders
            </div>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-sm-and-up">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="5"
              circle
            ></v-pagination>
          </v-flex>
          <v-flex xs12 class="text-xs-center hidden-xs-only">
            <v-pagination
              v-model="pageNo"
              :length="(pageCount ? pageCount : 0)"
              :total-visible="12"
              circle
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-container>

      <v-fab-transition>
        <v-btn
          color=primary
          dark
          fab
          fixed
          bottom
          right
          class="mr-4"
          to="/voucher"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import router from '../router'
import moment from 'moment'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      drawer: false,
      rightDrawer: false,
      loading: false,
      frmValid: true,
      txtName: '',
      cboSort: null,
      sorts: [
        {
          caption: 'Latest',
          value: 'createdDateTime:desc'
        },
        {
          caption: 'Name',
          value: 'name:asc'
        }
      ],
      items: [],
      listLimit: 10,
      listOffset: 0,
      listTotal: 0,
      listCountFrom: 0,
      listCountTo: this.listLimit,
      pageNo: parseInt(this.$route.query.pg) || 1,
      pageCount: 0
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getVouchers()
    // this.detectBottomOfWindow()
  },

  watch: {
    pageNo (val, oldVal) {
      // If page no changes, navigate to new page
      this.getVouchers(this.txtName, this.cboSort, (val - 1) * this.listLimit)
    }
  },

  methods: {
    refreshList: function () {
      this.items = []
      var _this = this
      return new Promise(function (resolve, reject) {
        var promise = _this.getVouchers(_this.txtName, _this.cboSort, 0)
        promise.then(function () {
          resolve()
        })
      })
    },
    detectBottomOfWindow: function () {
      window.onscroll = () => {
        // console.log(document.documentElement.scrollTop + window.innerHeight) - 48;
        // console.log(document.documentElement.offsetHeight);
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight

        if (bottomOfWindow) {
          if (this.listTotal > this.items.length) {
            this.getVouchers(this.txtName, this.cboSort, this.items.length)
          }
        }
      }
    },
    getVouchers: function (name = '', sort = '', offset = 0) {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/vouchers?name=' + name + '&sort=' + sort + '&limit=' + _this.listLimit + '&offset=' + offset)
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              for (var c = 0; c < resp.data.data.length; ++c) {
                resp.data.data[c].createdDateTimeDisplay = moment(resp.data.data[c].createdDateTime, _this.iso8601Format()).fromNow()
              }
              _this.items = resp.data.data
              _this.listLimit = resp.data.limit
              _this.listOffset = resp.data.offset
              _this.listTotal = resp.data.total
              _this.pageCount = Math.ceil(_this.listTotal / _this.listLimit)
              _this.listCountFrom = _this.listOffset + 1
              _this.listCountTo = (_this.listCountFrom - 1) + _this.items.length
              if (_this.items.length === 0) {
                _this.listCountFrom = 0
                _this.listCountTo = 0
              }
            } else {
              console.log('unable to load vouchers: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    },
    clearFilter () {
      this.$refs.form.reset()
      this.items = []
      this.getVouchers(this.txtName, this.cboSort)
      this.rightDrawer = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabs__slider {
  height: 3px;
}

form {
  width: 100%;
}

</style>
